import { createFileRoute } from "@tanstack/react-router";

import { AdminTopbar } from "@/components/admin/AdminTopbar";
import { CategoriesTab } from "@/components/admin/catalogo/CategoriesTab";
import { CollarsTab } from "@/components/admin/catalogo/CollarsTab";
import { CostTypesTab } from "@/components/admin/catalogo/CostTypesTab";
import { FitsTab } from "@/components/admin/catalogo/FitsTab";
import { GroupsTab } from "@/components/admin/catalogo/GroupsTab";
import { PiecesTab } from "@/components/admin/catalogo/PiecesTab";
import { RulesTab } from "@/components/admin/catalogo/RulesTab";
import { SizesTab } from "@/components/admin/catalogo/SizesTab";
import { TextsTab } from "@/components/admin/catalogo/TextsTab";
import { ThemesTab } from "@/components/admin/catalogo/ThemesTab";
import { FilterChip } from "@/components/admin/primitives";

type Tab =
  | "pecas"
  | "grupos"
  | "regras"
  | "custos"
  | "categorias"
  | "temas"
  | "golas"
  | "modelagens"
  | "tamanhos"
  | "textos";

const TABS: { value: Tab; label: string }[] = [
  { value: "pecas", label: "Peças" },
  { value: "grupos", label: "Grupos e preços" },
  { value: "regras", label: "Regras de preço" },
  { value: "custos", label: "Tipos de custo" },
  { value: "categorias", label: "Categorias" },
  { value: "temas", label: "Temas" },
  { value: "golas", label: "Golas" },
  { value: "modelagens", label: "Modelagens" },
  { value: "tamanhos", label: "Tamanhos" },
  { value: "textos", label: "Textos" },
];

/**
 * Catálogo — tudo o que define o produto e o preço.
 *
 * A aba fica na URL de propósito: mexer em catálogo é trabalho de ir e voltar
 * entre peça e grupo, e um F5 no meio disso não pode devolver a primeira aba.
 */
export const Route = createFileRoute("/admin/_painel/catalogo/")({
  validateSearch: (search: Record<string, unknown>): { aba?: Tab } => {
    const value = search["aba"];
    return TABS.some((tab) => tab.value === value) ? { aba: value as Tab } : {};
  },
  head: () => ({ meta: [{ title: "Catálogo — Painel MonteBox" }] }),
  component: AdminCatalogo,
});

function AdminCatalogo() {
  const { aba = "pecas" } = Route.useSearch();
  const navigate = Route.useNavigate();

  return (
    <>
      <AdminTopbar title="Catálogo" />

      <div className="flex flex-col gap-6 p-4 sm:p-8">
        <div className="flex items-center gap-2">
          {TABS.map((tab) => (
            <FilterChip
              key={tab.value}
              active={aba === tab.value}
              onClick={() => void navigate({ search: { aba: tab.value } })}
            >
              {tab.label}
            </FilterChip>
          ))}
        </div>

        {aba === "pecas" && <PiecesTab />}
        {aba === "grupos" && <GroupsTab />}
        {aba === "regras" && <RulesTab />}
        {aba === "custos" && <CostTypesTab />}
        {aba === "categorias" && <CategoriesTab />}
        {aba === "temas" && <ThemesTab />}
        {aba === "golas" && <CollarsTab />}
        {aba === "modelagens" && <FitsTab />}
        {aba === "tamanhos" && <SizesTab />}
        {aba === "textos" && <TextsTab />}
      </div>
    </>
  );
}
